import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ErrorFormCommissioningEnum } from '@bo-client/activation-management/shared/forms/create-forms-errors-model';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';

@Injectable()
export abstract class GridRegistrationFormBase extends RequestFormBase<GridRegistrationModel> {
  // Extracts error messages from the formGroup
  // and returns them as a List of ShowErrorModel
  getAllValidationErrors(): ShowErrorModel[] {
    const errors: ShowErrorModel[] = [];

    const getErrorsRecursive = (form: FormGroup | FormArray, prefix?: string) => {
      Object.keys(form.controls).forEach((field) => {
        const control = form.get(field);

        if (
          (control instanceof FormControl || control instanceof FormGroup || control instanceof FormArray) &&
          control.errors
        ) {
          // If the control is a FormControl and has errors
          const errorKeys = Object.keys(control.errors);
          errorKeys.forEach((key) => {
            let errorMessage: ShowErrorModel;
            const errorPrototype = ErrorFormCommissioningEnum.find(
              (x) => x.controlName === (prefix || '') + field
            );
            if (errorPrototype) {
              errorMessage = errorPrototype;
            } else {
              errorMessage = new ShowErrorModel();
              errorMessage.displayName = field;
              errorMessage.controlName = field;
              switch (key) {
                case 'required':
                  errorMessage.errorMessage = `ist ein Pflichtfeld.`;
                  break;
                default:
                  errorMessage.errorMessage = `ist nicht gültig.`;
              }
            }

            errors.push(errorMessage);
          });
        }
        if (control instanceof FormGroup || control instanceof FormArray) {
          const appendFieldName = isNaN(Number(field));
          // If the control is a FormGroup or FormArray, recursively search for errors
          getErrorsRecursive(control, appendFieldName ? (prefix || '') + field + '.' : prefix);
        }
      });
    };

    getErrorsRecursive(this.getFormGroup());

    return errors;
  }
}
